import React from 'react';
import classNames from 'classnames';

import { ButtonLink } from '../button';

import styles from './SkipLink.module.css';

interface Props {
  elementId: string;
  buttonText: string;
}

export const SkipLink = ({ elementId, buttonText }: Props) => {
  const preventDefaultEvent = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    document.getElementById(elementId)?.focus();
  };

  return (
    <ButtonLink
      to={`#${elementId}`}
      buttonStyle="inlineLinkLight"
      className={classNames(styles.skipLink, 'with-keyboard-focus')}
      onClick={preventDefaultEvent}>
      {buttonText}
    </ButtonLink>
  );
};
